import { Card, Col, Row, Typography } from "antd";
import React from "react";
import {
  AboutIcon,
  BankListIcon,
  LanguageIcon,
  LogoutIcon,
  ServiceIcon,
  TermIcon,
  ProfileEditIcon,
} from "../../lib/svg_help";

const { Text } = Typography;

export default function ProfilePage({ colors }) {
  const profileMenuItems = [
    {
      key: "language",
      label: "Language",
      icon: <LanguageIcon colors={colors} />,
    },
    {
      key: "bank",
      label: "Bank Account Lists",
      icon: <BankListIcon colors={colors} />,
    },
    {
      key: "support",
      label: "Customer Services",
      icon: <ServiceIcon colors={colors} />,
    },
    {
      key: "about",
      label: "About Customer Slot",
      icon: <AboutIcon colors={colors} />,
    },
    {
      key: "terms",
      label: "Terms and Conditions",
      icon: <TermIcon colors={colors} />,
    },
    { key: "logout", label: "Logout", icon: <LogoutIcon colors={colors} /> },
  ];
  return (
    <div>
      <Row align="middle" style={{ margin: "20px" }}>
        <Col span={12} style={{ position: "relative" }}>
          <img src="assets/profile_img.png" alt="profile_img" />
          <div
            style={{
              position: "absolute",
              right: 110,
              bottom: 0,
              borderRadius: "50%",
              padding: "4px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor : colors.background
            }}
          >
            <ProfileEditIcon colors={colors} />
          </div>
        </Col>

        <Col span={12}>
          <Row style={{ marginBottom: "8px" }}>
            <Col span={12}>ID</Col>
            <Col span={12}>: XXXXXXXX</Col>
          </Row>
          <Row style={{ marginBottom: "8px" }}>
            <Col span={12}>Account</Col>
            <Col span={12}>: 4536234</Col>
          </Row>
          <Row style={{ marginBottom: "8px" }}>
            <Col span={12}>Main Wallet</Col>
            <Col span={12}>: 10,000 MMK</Col>
          </Row>
          <Row>
            <Col span={12}>Promo Wallet</Col>
            <Col span={12}>: 1,000 MMK</Col>
          </Row>
        </Col>
      </Row>

      <Row gutter={[0, 14]} style={{ marginBottom: "16px" }}>
        {profileMenuItems.map((item) => (
          <Col span={24} key={item.key}>
            <Card
              hoverable
              styles={{ body: { padding: 0, margin: 0 } }}
              style={{
                borderRadius: "20px",
                padding: "10px 16px",
                backgroundColor : colors.background
              }}
              onClick={() => console.log(item.label)}
            >
              <Row align="middle" justify="space-between">
                <Col>
                  <Row
                    align="middle"
                    gutter={8}
                    style={{ display: "flex", alignItems: "center" }}
                  >
                    <Col style={{ display: "flex", alignItems: "center" }}>
                      {React.cloneElement(item.icon)}
                    </Col>
                    <Col>
                      <Text>{item.label}</Text>
                    </Col>
                  </Row>
                </Col>
                <Col>
                  <img
                    src="assets/arrow_right.png"
                    alt="arrow"
                    style={{
                      width: 16,
                      height: 16,
                    }}
                  />
                </Col>
              </Row>
            </Card>
          </Col>
        ))}
      </Row>
    </div>
  );
}
